import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useDispatch } from 'react-redux';

import { handleErrors } from '../../actions/ErrorActions';
import { forceSavedSearchRefresh } from '../../actions/SavedSearchesActions';
import { addSuccess } from '../../actions/SuccessActions';
import { publishPowerBIRecords } from '../../api/powerbi';
import { POWERBI_ENTITY_NAME } from '../../constants/PowerBIConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getSelectedReportIds } from '../../utils/powerBIUtils';

const useStyles = makeStyles({
  modal: {
    minWidth: 500,
    zIndex: 1200,
  },
});

const ConfirmPublishModal = ({ onClose, setLoading, selectedReports, setSelectedReports }) => {
  const translateString = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const handlePublish = async () => {
    setLoading(true);

    const selectedReportIds = getSelectedReportIds(selectedReports);
    const response = await publishPowerBIRecords(selectedReportIds);

    if (!response.hasError) {
      dispatch(addSuccess({ message: 'Published successfully' }));
      dispatch(forceSavedSearchRefresh(POWERBI_ENTITY_NAME, true));
      setSelectedReports([]);
    } else {
      dispatch(handleErrors(response.errors));
    }

    setLoading(false);
    onClose();
  };

  return (
    <Modal
      open
      variant="default"
      onClose={onClose}
      title={translateString('Confirm Publish')}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={[
        {
          label: translateString('Cancel'),
          'ui-ta': 'CancelPowerBIPublish',
        },
        {
          label: translateString('Ok'),
          onClick: handlePublish,
          'ui-ta': 'ConfirmPowerBIPublish',
        },
      ]}
    >
      <Typography>{translateString('Do you want to Publish the selected reports?')}</Typography>
    </Modal>
  );
};

export default ConfirmPublishModal;
